import React, { memo, useMemo } from 'react';
import { SlDropdownMenu } from 'src/components/BeaconV2Components/Header/SLDropdownMenu/input';
import { useMicroTrendsTimePeriodStore, MicroTrendTimePeriod } from './MicroTrendStore';

const TIME_PERIOD_OPTIONS: Array<{ id: MicroTrendTimePeriod['id']; label: string }> = [
  { id: 'ytd', label: 'YTD' },
  { id: '13w', label: 'Last 13 Weeks' },
  { id: '26w', label: 'Last 26 Weeks' },
  { id: '52w', label: 'Last 52 Weeks' }
];

const MicroTrendTimePeriodDropdown = () => {
  const timePeriod = useMicroTrendsTimePeriodStore((state) => state.timePeriod);
  const setTimePeriod = useMicroTrendsTimePeriodStore((state) => state.setTimePeriod);

  const handleTimePeriodChange = (option: { id: MicroTrendTimePeriod['id']; label: string }) => {
    setTimePeriod(option.id);
  };

  const selectedOption = useMemo(() => {
    return TIME_PERIOD_OPTIONS.find((option) => option.id === timePeriod.id) || TIME_PERIOD_OPTIONS[0];
  }, [timePeriod.id]);

  return (
    <SlDropdownMenu
      onChange={handleTimePeriodChange}
      disabled={true}
      defaultLabel={selectedOption.label}
      selectedId={selectedOption.id}
      options={TIME_PERIOD_OPTIONS}
    />
  );
};

export default memo(MicroTrendTimePeriodDropdown);
